import React from 'react'

const Stats = () => {
    return (
        <div className='stats'>
            <div className="stat">
                <div className="title">84 Million</div>
                <div className="desc">Forcibly displaced people worldwide</div>
            </div>
            <div className="stat">
                <div className="title">26.6 Million</div>
                <div className="desc">Refugees (as of mid-2021)</div>
            </div>
            <div className="stat">
                <div className="title">68%</div>
                <div className="desc">Originate from just 5 countries</div>
            </div>
        </div>
    )
}

export default Stats